/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { FC, useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { DescriptionForm, DescriptionPages } from 'components/DescriptionForm'
import { MarkedQuestionsTabs } from './consts'
import * as classes from './styles'

const tabs = Object.values(MarkedQuestionsTabs).map((item) => ({ id: item, title: item }))

export const MarkedQuestions: FC = () => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === MarkedQuestionsTabs.DESCRIPTION) {
      return <DescriptionForm page={DescriptionPages.MarkedQuestions} />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Marked Questions
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
